import {
  HD_THUMBNAIL_DIMENSIONS,
  LARGE_THUMBNAIL_DIMENSIONS,
  THUMBNAIL_DIMENSIONS,
} from "@shared/constants/fileDimensions";
import type { Asset as AssetType } from "@shared/types/asset";
import type { Product as AssetTemplate } from "@shared/types/product";

export const getMachineThumbnail = (
  machine: AssetType | AssetTemplate,
  isPreview = false,
  isHD = false,
  isOriginal = false,
  defaultLogoPath = "/images/default/thumbnail.svg",
) => {
  const thumbnailDimensions = isOriginal
    ? ""
    : isHD
    ? HD_THUMBNAIL_DIMENSIONS
    : isPreview
    ? LARGE_THUMBNAIL_DIMENSIONS
    : THUMBNAIL_DIMENSIONS;
  if (machine?.thumbnail) {
    return machine.thumbnail + thumbnailDimensions;
  } else if (machine?.image) {
    return machine.image + thumbnailDimensions;
  } else if (machine?.oem?.logo) {
    return machine.oem.logo + thumbnailDimensions;
  }
  return defaultLogoPath;
};
